import api from '../utils/api';

/**
 * O custo em CRÉDITOS de cada operação — lido do catálogo, nunca do código.
 *
 * MEDIDO 2026-09-07, conferindo os cinco números que o popover de saldo
 * escrevia à mão contra `janus-operations-management/deploy/seed_operations.py`:
 *
 * | a tela dizia | slug | o catálogo diz |
 * |---|---|---|
 * | Criar Prospect: 1 | `PROSPECT_CREATE` | 1 ✓ |
 * | Promover para Deal: 2 | `PROSPECT_PROMOTE_DEAL` | 2 ✓ |
 * | Revelar Contato: 5 | `CONTACT_REVEAL` | 5 ✓ |
 * | **Gerar Briefing: 5** | `SDR_MEETING_PREP` | **2** ✗ |
 * | Personalizar Email: 3 | `SDR_TEMPLATE_PERSONALIZE` | 3 ✓ |
 *
 * Quatro certos e um errado por 2,5× — e o mesmo 5 errado gateava o botão
 * em `DealBriefing` (`BRIEFING_CREDIT_COST`), então quem tinha 3 créditos
 * lia "você não pode" para uma operação de 2.
 *
 * Reprecificar é uma edição de catálogo, não um deploy: com a tabela no
 * código, a tela continuaria dizendo o preço velho depois de o preço mudar.
 */

/** `{ slug: credit_cost }` — slugs do catálogo, verbatim. */
export type OperationCosts = Record<string, number>;

export interface OperationCostsResponse {
  costs: OperationCosts;
  version: string;
}

export const operationCostsApi = {
  get: async (): Promise<OperationCosts> => {
    const { data } = await api.get<OperationCostsResponse>('/config/operation-costs');
    // O catálogo responde com o envelope { pricing: {...} }; aceita também o mapa plano.
    const bruto = data?.costs as unknown;
    const mapa =
      bruto && typeof bruto === 'object' && 'pricing' in bruto
        ? (bruto as { pricing: unknown }).pricing
        : bruto;
    if (!mapa || typeof mapa !== 'object') return {};
    return Object.fromEntries(
      Object.entries(mapa as Record<string, unknown>).filter(
        ([, v]) => typeof v === 'number' && Number.isFinite(v),
      ),
    ) as OperationCosts;
  },
};

export default operationCostsApi;
